import React, { FC } from "react";
import ForgotPassword from "../molecules/ForgotPassword";
import "../../static/css/Login.css";
import AuthCard from "../atoms/AuthCard";
const ForgotPasswordPage: FC = () => {
  return (
   
  <>
  <AuthCard
  title="Forgot password"
  form = { < ForgotPassword />}
  />
  </>
  );
};

export default ForgotPasswordPage;